'use strict';

var processInclude = require('../../../../../../app_storefront_base/cartridge/client/default/js/util');

$(document).ready(function () {
    processInclude(require('app_schuurman/components/wof-form'));
    processInclude(require('app_schuurman/components/wof-adress-form'));
    processInclude(require('app_schuurman/components/wof-spin'));
});
